import { render } from "./NColorPicker.vue?vue&type=template&id=5c35659c&ts=true"
import script from "./NColorPicker.vue?vue&type=script&lang=ts"
export * from "./NColorPicker.vue?vue&type=script&lang=ts"

import "./NColorPicker.vue?vue&type=style&index=0&id=5c35659c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__